import * as React from "react";
import { FormControlLabel, Checkbox } from "@mui/material";
const LabeledCheckbox = ({ checked, setChecked, onChange, children, className, checkboxClassName, disabled, id, }) => {
    return (React.createElement(FormControlLabel, { className: className, control: React.createElement(Checkbox, { id: id, className: checkboxClassName, size: "small", checked: checked, disabled: disabled, onChange: e => {
                if (setChecked !== undefined) {
                    setChecked(e.target.checked);
                }
                if (onChange !== undefined) {
                    onChange(e.target.checked);
                }
            } }), label: children }));
};
export default LabeledCheckbox;
